import { React, useCallback, useState } from 'react';
import Typography from '@mui/material/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import { styled } from '@mui/material/styles';
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai';

import { ContainerInput, Input } from './style.js';
import InputMask from 'react-input-mask';

const InputDefault = ({ Width, Margin, Text, TooltipText, Mask, Type, ...rest }) => {
  const StyledTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))`
    & .MuiTooltip-tooltip {
      background: #4d4d4d;
    }
  `;

  const [viewPassword, setViewPassword] = useState(false);

  const showOrHideViewPassword = useCallback(() => {
    console.log(`setViewPassword ${viewPassword}`);
    setViewPassword(!viewPassword);
  }, [viewPassword]);

  return (
    <ContainerInput Width={Width} Margin={Margin}>
      {TooltipText ? (
        <StyledTooltip
          title={
            <Typography fontSize={16} color={'#fff'}>
              {TooltipText}
            </Typography>
          }
          placement="bottom-start">
          {Text && <label>{Text}</label>}
        </StyledTooltip>
      ) : (
        Text && <label>{Text}</label>
      )}
      {Mask && Type !== 'password' ? (
        <InputMask mask={Mask} {...rest}>
          {(inputProps) => <Input style={{ width: '100%' }} {...inputProps} />}
        </InputMask>
      ) : (
        <>
          {Type === 'password' ? (
            <>
              <div style={{ display: 'flex' }}>
                <Input
                  type={!viewPassword ? 'password' : 'text'}
                  style={{ width: '100%' }}
                  {...rest}
                />
                <span
                  style={{
                    'font-size': '23px',
                    padding: '4px',
                    cursor: 'pointer',
                    height: '35px',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                  onClick={() => showOrHideViewPassword()}>
                  {!viewPassword ? <AiFillEye /> : <AiFillEyeInvisible />}
                </span>
              </div>
            </>
          ) : (
            <Input style={{ width: '100%' }} {...rest} />
          )}
        </>
      )}
    </ContainerInput>
  );
};

export default InputDefault;
